import React from "react"
import styled from "styled-components"
import { Props as ModalProps } from "react-modal"
import colors from "@constants/colors"
import { smallcapsBold13Styles } from "@constants/typography"
import { Chevron } from "@components/icons"
import Modal from "../index"
import TextBlock from "@components/TextBlock"
import { MobileAndTabletOnly } from "@utils/MediaQuery"

const Container = styled.div``

const Header = styled.div`
  display: flex;
  height: 72px;
  margin-bottom: 40px;
  padding: 0 20px;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid ${colors.dividerLineGray};
`

const HeaderButton = styled.button`
  cursor: pointer;
  width: 32px;
  height: 32px;
  margin-right: 8px;
  padding: 0;
  transform: rotate(180deg) translateY(1px);
  outline: none;
  background: none;
  border: none;
`

const HeaderText = styled.div`
  ${smallcapsBold13Styles}
`

interface ReturnPolicyModalProps extends ModalProps {
  content: React.ReactNode
}

const ReturnPolicyModal: React.FC<ReturnPolicyModalProps> = (
  props: ReturnPolicyModalProps
) => (
  <Modal {...props}>
    <Container>
      <MobileAndTabletOnly>
        <Header onClick={props.onRequestClose}>
          <HeaderButton>
            <Chevron strokeColor={colors.black} />
          </HeaderButton>
          <HeaderText>Back</HeaderText>
        </Header>
      </MobileAndTabletOnly>
      <TextBlock content={props.content} />
    </Container>
  </Modal>
)

export default ReturnPolicyModal
